export default __webpack_public_path__ + "static/media/error_server_two.2c40959d.svg";